import { useAtom } from 'jotai'
import {
  isMJStyleModelAtom,
  modelCodeAtom,
  patternAtom,
  selectModelAtom,
  selectResolutionAtom,
} from './ai-form/atom'
import {
  AiCreateArtworkModel,
  AiCreateArtworkPattern,
  SuperType,
} from '~/graphqls/types'
import { isControlnetPattern } from '~/configs/ai'

export const useType = () => {
  const [selectModel] = useAtom(selectModelAtom)
  const [isMJStyleModel] = useAtom(isMJStyleModelAtom)
  const [pattern] = useAtom(patternAtom)
  const [modelCode] = useAtom(modelCodeAtom)
  const [selectResolution] = useAtom(selectResolutionAtom)

  const isMJ = selectModel === AiCreateArtworkModel.MIDJOURNEY
  const isMJ6 = [303, 304, 305].includes(modelCode)
  const isMJ61 = [305].includes(modelCode)
  const isMJ7 = [306].includes(modelCode)

  const isBigMJ = isMJ || isMJStyleModel

  const isSD = selectModel === AiCreateArtworkModel.STABLE_DIFFUSION

  const isAD = selectModel === AiCreateArtworkModel.ANIME_DIFFUSION

  const isST = selectModel === AiCreateArtworkModel.STYLE

  const isMask = pattern === AiCreateArtworkPattern.MASK

  const isControlnet = isControlnetPattern(pattern)

  const isGeneral = pattern === AiCreateArtworkPattern.GENERAL

  const isTransparent = pattern === AiCreateArtworkPattern.LAYER_DIFFUSION

  const is4k = selectResolution?.endsWith(`*${SuperType.FOUR_K}`)
  const isNano = modelCode === 803

  return {
    /** MJ模型 */
    isMJ,
    /** MJ V6模型 */
    isMJ6,
    /** MJ V6.1模型 */
    isMJ61,
    /** MJ V7模型 */
    isMJ7,
    /** 包括MJ模型和MJ风格模型 */
    isBigMJ,
    /** 通用模型 */
    isSD,
    /** 漫画模型 */
    isAD,
    /** 风格模型 */
    isST,
    /** 涂抹 */
    isMask,
    /** controlnet */
    isControlnet,
    /** 透明图 */
    isTransparent,
    /** 常规作画 */
    isGeneral,
    /** 当前是否处于4k作画模式，即分辨率选了4k分辨率 */
    is4k,
    isNano,
  }
}
